module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Menu"
  }, _vm._l((_vm.items), function(item, index) {
    return (_vm.suite.id) ? _c('router-link', {
      key: "index",
      staticClass: "Menu-item",
      class: ("Menu-item--" + (item.name)),
      style: (_vm.menuItemStyle(item, index)),
      attrs: {
        "to": {
          name: item.name
        }
      }
    }, [_c('div', {
      staticClass: "Menu-itemContent"
    }, [_c('div', {
      staticClass: "Menu-itemLabel",
      style: ({
        top: ((item.offsetY) + "px")
      })
    }, [(item.supertitle) ? _c('div', {
      staticClass: "Menu-itemSupertitle",
      domProps: {
        "innerHTML": _vm._s(item.supertitle)
      }
    }) : _vm._e(), _vm._v(" "), (item.title) ? _c('div', {
      staticClass: "Menu-itemTitle",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    }) : _vm._e(), _vm._v(" "), (item.icon) ? _c('icon', {
      staticClass: "Menu-itemIcon",
      attrs: {
        "name": item.icon
      }
    }) : _vm._e()], 1)])]) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d6c76ce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 364
// module chunks = 1